import React, { Component } from 'react';
import { Panel } from "react-bootstrap";

import Spinner from '@components/Spinner';
import Table from "@modules/Table";

import '@assets/css/apiData.css';

import { toFormattedNumber } from "@sm/utils/utils";
import { DASHBOARD_PAYOUT_COUNTRIES_EVENT } from '@sm/actions/types';
const store =  require('@sm/reducers/index');

class DashBoardPayoutCountriesComponent extends Component {

  constructor(props) {
    super(props);

    this.state = {
      payout: undefined,
      loading: true,
      socket: false,
      columns: [{
        value: "country",
        label: "Country"
      }, {
        value: "amount",
        label: "Total",
        rightAligned: true,
        isNumber: true
      }]
    };
  }

  subscribeFunction = null;

  componentDidMount(){
    this.subscribeFunction = store.default.subscribe(() => {
      const state = store.default.getState().dashboardReducer;

      if (state.update === "LOADING") {
        this.setState({
          loading: true
        });
      }

      if (state.update === DASHBOARD_PAYOUT_COUNTRIES_EVENT && this.props.thisMonth && state.payoutcountry.socket) {
        this.setState({ payout: state.payoutcountry, loading: false, socket: state.payoutcountry.socket });
        return;
      }

      if (state.update === DASHBOARD_PAYOUT_COUNTRIES_EVENT && !state.payoutcountry.socket) {
        this.setState({ payout: state.payoutcountry, loading: false, socket: state.payoutcountry.socket });
      }
    });
  }

  componentWillUnmount() {
    if (this.subscribeFunction) {
      this.subscribeFunction();
    }
  };

  tableData = () => {
    const { payout } = this.state;

    if (!payout) {
      return [];
    }

    const firstColumn = this.state.columns[0].value;
    return payout.sort((elem1, elem2) => elem1[firstColumn].localeCompare(elem2[firstColumn]))
      .map(elem => {
        return {
          country: elem.country,
          amount: elem.currency + " " + toFormattedNumber(elem.amount),
          fxFee: elem.currency + " " + toFormattedNumber(elem.fxFee),
          sellFee: elem.currency + " " + toFormattedNumber(elem.sellFee)
        };
      });
  };

  render() {
    const { payout, loading, columns } = this.state;

    let payoutWrap = (
      <Panel>
        <Panel.Heading>
          <Panel.Title> PAYOUTS PER COUNTRY </Panel.Title>
        </Panel.Heading>
        <Panel.Body>
          <Spinner smallContainer={ true } />
        </Panel.Body>
      </Panel>
    );

    if (!loading && payout) {
      payoutWrap = (
        <Panel style={ { height: '100%' } }>
          <Panel.Heading>
            <Panel.Title> PAYOUTS PER COUNTRY </Panel.Title>
          </Panel.Heading>
          <Panel.Body>
            <div className="panel-content table-content">
              <Table
                columns={ columns }
                headerColor={ "#DFDFDF" }
                data={ this.tableData() }
                isStriped={ false }
              />
            </div>
          </Panel.Body>
        </Panel>
      );
    }
    return payoutWrap;
  }

}

export default DashBoardPayoutCountriesComponent;